import React from 'react';
import { useSelector } from 'react-redux';
import { TABS_CONFIG, TabType } from './consts';
import './MyAccountTabs.scss';
import EAChoiceChip from '../../shared/ChoiceChip/EAChoiceChip';
import useDesktopSize from '../../../../utils/hooks/useDesktopSize';
import { State } from '../../../store';
import { useMobileScrollNav } from './useMobileScrollNav';
import { useTranslation } from 'react-i18next';

interface IProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const MyAccountTabs: React.FC<IProps> = ({ activeTab, onTabChange }) => {
  const isDesktop = useDesktopSize();
  const ecardShowCode = useSelector((state: State) => state.config.configuration.ecard_showCode);
  const allowSubaccounts = useSelector((state: State) => state.config.configuration.allowSubaccounts === true);
  const scrollContainerRef = useMobileScrollNav(activeTab);
  const { t } = useTranslation();
  // Filtrujemy taby na podstawie konfiguracji
  const visibleTabs = TABS_CONFIG.filter((tab) => {
    if (tab.requiresConfig === "ecard_showCode") {
      return ecardShowCode;
    }
    if (tab.requiresConfig === "allowSubaccounts") {
      return allowSubaccounts;
    }
    return true;
  });

  return (
    <div className="my-account-v2__navigation" ref={scrollContainerRef}>
      {visibleTabs.map((tab) => (
        <div key={tab.id} data-tab-id={tab.id}>
          <EAChoiceChip
            label={isDesktop ? t(tab.desktopLabel) : t(tab.mobileLabel)}
            isSelected={activeTab === tab.id}
            onClick={() => onTabChange(tab.id)}
            size="small"
            icon={React.createElement(tab.icon as any)}
          />
        </div>
      ))}
    </div>
  );
};

export default MyAccountTabs;
